import { render, staticRenderFns } from "./empty.vue?vue&type=template&id=38806154&lang=pug"
import script from "./empty.vue?vue&type=script&lang=coffee"
export * from "./empty.vue?vue&type=script&lang=coffee"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports